import React from "react";

const Grap = () => {
  const downloadalert = () => {
    alert("You Click On Download Button");
  };
  return (
    <div class="grap-contaner">
      <div class="grap-head">
        <div class="select">
          <select name="" id="">
            <option value="">Bulan Ini</option>
            <option value="">Bulan Ini</option>
            <option value="">Bulan Ini</option>
          </select>
        </div>
        <div class="report">
          <button
            className="down-btn"
            onClick={() => {
              downloadalert();
            }}
          >
            DOWNLOAD REPORT
          </button>
        </div>
      </div>
    </div>
  );
};

export default Grap;
